import React, { ReactNode } from 'react';
import { ErrorResponse } from '@eika-infrastruktur/request';
import classNames from 'classnames';
import Card, { CardProps } from './Card';

import '@eika/card-style/src/ErrorCard.scss';
import { ErrorCardExceptionInformation } from './ErrorCardExceptionInformation';

type RequestExceptionWithResponse = import('@eika-infrastruktur/request').RequestExceptionWithResponse;

export interface ErrorCardProps extends Omit<CardProps, 'children'> {
    exception?: ErrorResponse | RequestExceptionWithResponse;
    description?: JSX.Element | string;
    showMoreText?: string;
    showLessText?: string;
    children?: ReactNode;
}
const ErrorCard = ({
    children,
    className,
    isModal,
    title,
    description = '',
    icon,
    iconSize,
    exception,
    showMoreText = 'Vis mer',
    showLessText = 'Vis mindre',
    ...rest
}: ErrorCardProps): JSX.Element => {
    return (
        <Card
            {...rest}
            isModal={isModal}
            icon={icon}
            iconSize={iconSize}
            title={title}
            className={classNames(className, 'sgw-error-card')}
        >
            <div className="sgw-error-card__container">
                <div className="typography-paragraph">{description}</div>
                {exception && (
                    <ErrorCardExceptionInformation
                        exception={exception}
                        showMoreText={showMoreText}
                        showLessText={showLessText}
                    />
                )}
            </div>
            {children}
        </Card>
    );
};

export default ErrorCard;
